module.exports = __webpack_public_path__ + "static/img/13.c7d95c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/13.png
// module id = 39eO
// module chunks = 4